export default "__VITE_ASSET__CiOFFDXP__"